export default __webpack_public_path__ + "static/media/surveillance_camera.2aae1df5.svg";